// extracted by mini-css-extract-plugin
export default {"pricing":"CheckoutPricing_pricing__sTeB8"};